export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;
